export default function Release20151214() {
    return (
        <>
            <p>De seneste år er der sket et markant skred i underholdning fra traditionelt flow tv til et stort
               udvalg af streaming tilbud. Der er derfor opstået en efterspørgsel efter hurtigt og billigt
               bredbånd som giver forbrugeren fuld kontrol over sit valg af medier og underholdning, uanset
               om det er tv, serier, film, gaming eller eSport, og Hiper er netop skabt til at møde denne
               efterspørgsel.</p>

            <p>Hiper tilbyder fiberopkoblinger med 1.000 Mbit hastighed på TDC’s fibernet i
               hovedstadsregionen, det tidligere DONG-net, som når ud til mere end 100.000 husstande.
                &ldquo;Det er på tide at skrue op for hastigheden på fibernettet så kunderne omsider kan få glæde af
               teknologien&rdquo; siger Hipers medstifter og administrerende direktør Stig Myken.</p>

            <p>Hiper lancerer samtidig et bredbåndsprodukt på TDC’s kabel-tv net og Stig Myken er stolt og
               glad: &ldquo;Det er et historisk øjeblik. For første gang nogensinde får forbrugere i Danmark
               mulighed for at vælge mere end én bredbåndsleverandør via deres kabel-tv stik&rdquo;.</p>

            <p>Kabel-tv nettets koaksialkabler har stor kapacitet og egner sig glimrende til
               bredbåndsforbindelser, og samtlige alternative operatører har i flere år kæmpet for at få
               adgang til kabel-tv nettet på rimelige vilkår, som man kender det fra mobilnettene.</p>

            <p>Af tekniske årsager kræver det at kunderne har en tv-pakke fra Yousee for at Hiper kan levere
               bredbånd, men denne begrænsning fjernes fra april 2016 så Hiper også kan levere til kunder
               uden tv-pakker.</p>

            <p>&ldquo;Det har været et langt sejt træk og vilkårene for bredbånd over kabel-tv er ikke helt hvor de
                      skal være, men nu vil vi ud og møde kunderne på kabel-tv nettet&rdquo; siger Stig Myken.</p>

            <p>Endelig kan Hiper levere bredbånd over telefonlinjerne til stort set alle danske husstande.
                &ldquo;Hastigheden afhænger af linjen til den enkelte bolig, vi skruer forbindelsen op på højeste
               hastighed for alle kunder, til samme pris&rdquo; forklarer Stig Myken.</p>

            <p>Hiper er stiftet og ledes af Nicolai Lamborg, Stig Myken og Simon Skals som er erfarne
               personer fra den danske telebranche, og som brænder for at gøre det bedre og sætte nye
               standarder for, hvad kunderne kan forvente når det gælder hastighed og pris.</p>

            <p>&ldquo;Hiper har en mission om at levere bredbånd på alle åbne net og vi er klar til at lancere med
                      produkter på fiber, på kabel-TV og over telefonstikket så vi kan levere til alle, uanset hvor de
                      bor&rdquo; siger Stig Myken.</p>
        </>
    )
}
